import { SdkResource } from './common';

export const activity = SdkResource.from((client) => ({
  getByReference: (
    reference: string,
    filter?: Omit<{ reference?: string | string[] }, 'reference'>
  ) =>
    client
      .GET('/widgets/activities', {
        params: { query: { filter: JSON.stringify({ ...filter, reference }) } },
      })
      .then(({ data: response }) => response?.data || []),
}));
